module.exports = __webpack_public_path__ + "img/jifen2.6831077c.svg";